// extracted by mini-css-extract-plugin
var _1 = "ContractsTableSettingsModal-modulecheckbox__mhsjy";
export { _1 as "checkbox" }
